import React, { Component } from 'react';
import PropTypes from 'prop-types';
import bulletsMenuHOC from '../../../common/bulletsMenuHOC';
import MenuListButton from '../../../common/ui/MenuListButton';

class WorkerActionsMenu extends Component {
  static propTypes = {
    removeWorker: PropTypes.func.isRequired,
    workerDidNotShow: PropTypes.func.isRequired,
    hireWorker: PropTypes.func.isRequired,
    hireIsInMenu: PropTypes.bool.isRequired,
    removeIsInMenu: PropTypes.bool.isRequired,
    noShowIsInMenu: PropTypes.bool.isRequired
  };

  render () {
    const { removeWorker, workerDidNotShow, hireWorker, hireIsInMenu, removeIsInMenu, noShowIsInMenu } = this.props;
    return (
      <ul className='popupMenu'>
        { removeIsInMenu && <MenuListButton onClick={removeWorker} name='Remove' /> }
        { noShowIsInMenu && <MenuListButton onClick={workerDidNotShow} name='Worker did not show' /> }
        { hireIsInMenu && <MenuListButton onClick={hireWorker} name='Hire' /> }
      </ul>
    );
  }
}

export default bulletsMenuHOC(WorkerActionsMenu);



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/WorkersTab/WorkerActionsMenu.js